import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DEFAULT_PAGE_SIZE } from '../../const';
import { setTableUrlParams } from '../../routing/setTableUrlParams';
import { StoreFilterType, StoreGroupFilterType } from '../../types';
import { hashingData } from './functionSlice';

export interface ITableState {
    page: number;
    pageSize: number;
    sorter: string[];
    checkedList: string[];
    columns: any;
    dataRows: any[];
    count: number;
    filterFields: StoreFilterType;
    listGroupFilters: StoreGroupFilterType;
    prefixFetchKey: string;
    prefixFetchKeyUpdate: string;
    heightControlPanel: number;
    heightHeaderTable: number;
    heightPaginationPanel: number;
    flexibleFilters?: string;
    orderBy?: string[];
}

const initialState: ITableState = {
    page: 1,
    pageSize: +DEFAULT_PAGE_SIZE,
    checkedList: [],
    columns: [],
    dataRows: [],
    count: 0,
    sorter: [],
    filterFields: {},
    listGroupFilters: {},
    prefixFetchKey: '',
    prefixFetchKeyUpdate: '',
    heightControlPanel: 0,
    heightHeaderTable: 0,
    heightPaginationPanel: 0,
    ...setTableUrlParams(),
};

const slices: { [key: string]: any } = {};
const storeHash: { [keySlice: string]: { [key: string]: number } } = {};

export const tableSlice = (nameQuery: string) => {
    if (slices[nameQuery]) {
        return slices[nameQuery];
    }

    slices[nameQuery] = createSlice({
        name: 'table',
        initialState,
        reducers: {
            setterTable: (state, action: PayloadAction<Partial<ITableState>>) => {
                if (!storeHash[nameQuery]) {
                    storeHash[nameQuery] = {};
                }

                hashingData(storeHash[nameQuery], action.payload, 'checkedList');
                hashingData(storeHash[nameQuery], action.payload, 'columns');
                hashingData(storeHash[nameQuery], action.payload, 'dataRows');
                hashingData(storeHash[nameQuery], action.payload, 'sorter');

                if (!Object.keys(action.payload).length) {
                    return state;
                }

                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    });

    return slices[nameQuery];
};

export const getSetterTable = (nameQuery: string) => tableSlice(nameQuery).actions.setterTable;

export const getTableSlice = (nameQuery: string) => tableSlice(nameQuery).reducer;
